import React, { useEffect } from 'react';
import { Container, Typography, Box, Button, Paper, Divider } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useNavigate } from 'react-router-dom';
import { useGetUserAttributesQuery } from '../../store/userApi';

export default function SubscriptionSuccessPage() {
  const navigate = useNavigate();
  const { refetch } = useGetUserAttributesQuery();
  
  // Refetch user data to update subscription status
  useEffect(() => {
    refetch();
  }, [refetch]);
  
  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };
  
  const handleGoToTranscribe = () => {
    navigate('/transcribe');
  };
  
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center', borderRadius: 2 }}>
        <Box sx={{ color: 'success.main', mb: 2 }}>
          <CheckCircleOutlineIcon sx={{ fontSize: 80 }} />
        </Box>
        
        <Typography variant="h4" component="h1" gutterBottom>
          Subscription Successful!
        </Typography>
        
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Thank you for subscribing to the Pro plan. Your account has been activated with unlimited transcriptions.
        </Typography>
        
        <Divider sx={{ my: 4 }} />
        
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" gutterBottom>
            What's next?
          </Typography>
          
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            You now have access to unlimited transcriptions and all Pro features.
            Start transcribing your content right away or check your account details.
          </Typography>
        </Box>
        
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
          <Button 
            variant="contained" 
            color="primary" 
            size="large"
            onClick={handleGoToTranscribe}
          >
            Start Transcribing
          </Button>
          
          <Button 
            variant="outlined" 
            color="primary" 
            size="large"
            onClick={handleGoToDashboard}
          >
            Go to Dashboard
          </Button>
        </Box>
      </Paper>
    </Container>
  );
} 